/**
 * CMJMemberInfoDialog tournament registration mode.
 * Legacy: MajakFrame.cpp InitDialogMeeting / RequestCheckTournamentRegistContents.
 */
import { useState } from 'react'
import { showMessage } from '../../../utils/msgbox'
import TournamentBracketPreviewDlg, { TOURNAMENT_FORMATS } from './TournamentBracketPreviewDlg'

export interface TournamentRegistPayload {
  roomOption: string
  tournamentBaseRule: string
  tournamentMoneyRule: string
  tournamentName: string
  tournamentDate: string
  password: string
  maxViewer: number
  tournamentRegistFlag: number
}

interface Props {
  onOK: (payload: TournamentRegistPayload) => void
  onCancel: () => void
}

function pad2(value: number) {
  return String(value).padStart(2, '0')
}

function defaultStartDateTime() {
  const date = new Date(Date.now() + 2 * 60 * 60 * 1000)
  date.setMinutes(Math.ceil(date.getMinutes() / 10) * 10, 0, 0)
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`
}

function formatTournamentDate(value: string) {
  const [date, time] = value.split('T')
  return `${date.replace(/-/g, '/')} ${time || '00:00'}:00`
}

function legacyNameByteLength(value: string) {
  return Array.from(value).reduce((length, character) =>
    length + (/^[\x00-\x7f\uff61-\uff9f]$/.test(character) ? 1 : 2), 0)
}

export default function TournamentRegistDlg({ onOK, onCancel }: Props) {
  const [name, setName] = useState('')
  const [dateTime, setDateTime] = useState(defaultStartDateTime)
  const [hanTon, setHanTon] = useState(1)
  const [matchTime, setMatchTime] = useState(2)
  const [matchCount, setMatchCount] = useState(1)
  const [matchFormat, setMatchFormat] = useState(1)
  const [joinMoney, setJoinMoney] = useState('0')
  const [prize1, setPrize1] = useState('0')
  const [prize2, setPrize2] = useState('0')
  const [prize3, setPrize3] = useState('0')
  const [prize4, setPrize4] = useState('0')
  const [wareme, setWareme] = useState(false)
  const [kuitan, setKuitan] = useState(true)
  const [uma, setUma] = useState(0)
  const [agari, setAgari] = useState(0)
  const [red, setRed] = useState(true)
  const [speedFast, setSpeedFast] = useState(false)
  const [watcher, setWatcher] = useState(true)
  const [openHand, setOpenHand] = useState(false)
  const [viewerChat, setViewerChat] = useState(true)
  const [usePassword, setUsePassword] = useState(false)
  const [password, setPassword] = useState('')
  const [showBracketPreview, setShowBracketPreview] = useState(false)
  const selectedFormat = TOURNAMENT_FORMATS[matchFormat - 1]
  const minimumPlayers = selectedFormat ? Math.floor(selectedFormat.maxPlayers / 2) + 1 : 0

  const submit = () => {
    const trimmedName = name.trim()
    const errors: string[] = []
    const nameByteLength = legacyNameByteLength(trimmedName)
    if (nameByteLength < 8 || nameByteLength > 30) {
      errors.push('大会名は半角8～30文字（全角4～15文字）で入力してください。')
    } else if (/[\uff61-\uff9f]/.test(trimmedName)) {
      errors.push('大会名に半角カナは使用できません。')
    }

    const selectedDateTime = new Date(dateTime)
    const now = Date.now()
    if (!dateTime || Number.isNaN(selectedDateTime.getTime())) {
      errors.push('開催日時を入力してください。')
    } else if (selectedDateTime.getTime() < now + 70 * 60 * 1000) {
      errors.push('開催日時は現在から1時間10分以降に設定してください。')
    } else if (selectedDateTime.getTime() > now + 8 * 24 * 60 * 60 * 1000) {
      errors.push('開催日時は8日以内に設定してください。')
    }

    if (hanTon === 0 || matchTime === 0 || matchCount === 0 || matchFormat === 0) {
      errors.push('大会ルールをすべて選択してください。')
    }
    if ((Number(joinMoney) || 0) > 10_000) {
      errors.push('参加費は0～10,000 GPで入力してください。')
    }
    if ([prize1, prize2, prize3, prize4].some(value => (Number(value) || 0) > 100_000)) {
      errors.push('各順位の賞金は0～100,000 GPで入力してください。')
    }
    if (usePassword && password.trim().length === 0) {
      errors.push('パスワードを入力してください。')
    }
    if (errors.length > 0) {
      showMessage(errors.join('\n'), '入力内容を確認してください')
      return
    }

    const format = selectedFormat
    const roomOption = `${hanTon - 1}${uma}${speedFast ? 1 : 0}${kuitan ? 0 : 1}0${red ? 2 : 1}${openHand ? 1 : 0}${viewerChat ? 1 : 0}00${wareme ? 1 : 0}0${agari}0${viewerChat ? 1 : 0}`

    onOK({
      roomOption,
      tournamentBaseRule: `${format.maxPlayers}|${format.playMode}|${matchCount}|${matchTime}`,
      tournamentMoneyRule: `${Number(joinMoney) || 0}|${Number(prize1) || 0}|${Number(prize2) || 0}|${Number(prize3) || 0}|${Number(prize4) || 0}`,
      tournamentName: trimmedName,
      tournamentDate: formatTournamentDate(dateTime),
      password: usePassword ? password.trim() : '',
      maxViewer: watcher ? 12 : 0,
      tournamentRegistFlag: 1,
    })
  }

  return (
      <div className="majak-mobile-tournament-regist-overlay majak-mobile-dialog-overlay majak-room-setup-overlay majak-popup-overlay">
        <form
          className="majak-mobile-tournament-regist majak-mobile-dialog-panel majak-room-setup-dialog majak-popup-panel"
          onSubmit={event => { event.preventDefault(); submit() }}
          role="dialog"
          aria-modal="true"
          aria-label="大会登録"
        >
          <header className="majak-mobile-dialog-titlebar majak-popup-titlebar"><span>大会登録</span><button className="majak-popup-titlebar__close" type="button" onClick={onCancel} aria-label="閉じる">×</button></header>
          <div className="majak-mobile-tournament-regist__body majak-mobile-dialog-body majak-popup-body">
            <fieldset className="majak-mobile-dialog-section">
              <legend>大会設定</legend>
              <label className="majak-mobile-tournament-regist__wide"><span>大会名</span><input value={name} onChange={event => setName(event.target.value.slice(0, 30))} maxLength={30} autoFocus /></label>
              <label className="majak-mobile-tournament-regist__wide"><span>開催日時</span><input type="datetime-local" value={dateTime} onChange={event => setDateTime(event.target.value)} /></label>
              <label><span>東南/東風</span><select value={hanTon} onChange={event => setHanTon(Number(event.target.value))}><option value={0}>選択</option><option value={1}>東南戦</option><option value={2}>東風戦</option></select></label>
              <label><span>1試合の時間</span><select value={matchTime} onChange={event => setMatchTime(Number(event.target.value))}><option value={0}>選択</option><option value={1}>30分</option><option value={2}>40分</option><option value={3}>50分</option><option value={4}>60分</option></select></label>
              <label><span>試合数</span><select value={matchCount} onChange={event => setMatchCount(Number(event.target.value))}><option value={0}>選択</option><option value={1}>1半荘</option><option value={2}>2半荘</option></select></label>
              <label><span>大会形式</span><select value={matchFormat} onChange={event => setMatchFormat(Number(event.target.value))}><option value={0}>選択</option>{TOURNAMENT_FORMATS.map((format, index) => <option key={format.label} value={index + 1}>{format.label}</option>)}</select></label>
            </fieldset>

            <fieldset className="majak-mobile-dialog-section">
              <legend>参加費・賞金</legend>
              <label className="majak-mobile-tournament-regist__wide"><span>参加費</span><input inputMode="numeric" value={joinMoney} onChange={event => setJoinMoney(event.target.value.replace(/\D/g, '').slice(0, 5))} /></label>
              <label><span>賞金 1位</span><input inputMode="numeric" value={prize1} onChange={event => setPrize1(event.target.value.replace(/\D/g, '').slice(0, 6))} /></label>
              <label><span>賞金 2位</span><input inputMode="numeric" value={prize2} onChange={event => setPrize2(event.target.value.replace(/\D/g, '').slice(0, 6))} /></label>
              <label><span>賞金 3位</span><input inputMode="numeric" value={prize3} onChange={event => setPrize3(event.target.value.replace(/\D/g, '').slice(0, 6))} /></label>
              <label><span>賞金 4位</span><input inputMode="numeric" value={prize4} onChange={event => setPrize4(event.target.value.replace(/\D/g, '').slice(0, 6))} /></label>
              <label><span>ウマ</span><select value={uma} onChange={event => setUma(Number(event.target.value))}><option value={0}>5-10</option><option value={1}>10-20</option><option value={2}>10-30</option></select></label>
              <label><span>アガリ</span><select value={agari} onChange={event => setAgari(Number(event.target.value))}><option value={0}>頭ハネ</option><option value={1}>ダブロン</option><option value={2}>トリロン</option></select></label>
            </fieldset>

            <fieldset className="majak-mobile-tournament-regist__rules majak-mobile-dialog-section">
              <legend>ルール設定</legend>
              <div className="majak-mobile-tournament-regist__checks">
                <label><input type="checkbox" checked={wareme} onChange={event => setWareme(event.target.checked)} />ワレメあり</label>
                <label><input type="checkbox" checked={kuitan} onChange={event => setKuitan(event.target.checked)} />クイタンあり</label>
                <label><input type="checkbox" checked={red} onChange={event => setRed(event.target.checked)} />赤牌1枚</label>
                <label><input type="checkbox" checked={speedFast} onChange={event => setSpeedFast(event.target.checked)} />高速</label>
                <label><input type="checkbox" checked={watcher} onChange={event => setWatcher(event.target.checked)} />観戦可</label>
                <label><input type="checkbox" checked={openHand} onChange={event => setOpenHand(event.target.checked)} />手牌公開</label>
                <label className="majak-mobile-tournament-regist__wide"><input type="checkbox" checked={viewerChat} onChange={event => setViewerChat(event.target.checked)} />観戦者チャット可</label>
              </div>
              <div className="majak-mobile-tournament-regist__password">
                <label><input type="checkbox" checked={usePassword} onChange={event => setUsePassword(event.target.checked)} />カギをかける</label>
                <label><span>パスワード</span><input type="password" value={password} disabled={!usePassword} maxLength={8} onChange={event => setPassword(event.target.value.slice(0, 8))} /></label>
              </div>
            </fieldset>
            <section className="majak-tournament-regist-conditions majak-mobile-tournament-regist__conditions" aria-live="polite">
              <div><strong>開催条件</strong><button type="button" onClick={() => setShowBracketPreview(true)}>対戦表を確認</button></div>
              <ul>
                <li>開催最低人数：{minimumPlayers}人</li>
                <li>定員に満たない場合、残りの席はNPCが参加します。</li>
                <li>最低人数に満たない場合は中止となり、参加費を返却します。</li>
                <li>組み合わせは開始5分前にランダムで決定されます。</li>
                <li>賞金合計の110%は主催者のGPから登録時に預かり、中止時は返却します。</li>
              </ul>
            </section>
          </div>
          <footer className="majak-mobile-dialog-actions majak-popup-actions">
            <button type="button" className="majak-standard-dialog__secondary" onClick={onCancel}>キャンセル</button>
            <button type="submit" className="majak-standard-dialog__primary is-primary">大会登録</button>
          </footer>
        </form>
        {showBracketPreview && selectedFormat && (
          <TournamentBracketPreviewDlg format={selectedFormat} onClose={() => setShowBracketPreview(false)} />
        )}
      </div>
    )
}